import React, { memo } from 'react';
import { scrollToPurchase } from '../utils/checkout';
export function FinalCTA() {
  return <section className="bg-gradient-to-b from-[#2A1D10] via-[#3B2A1A] to-[#2A1D10] py-20 md:py-28 px-4 text-white text-center" data-id="element-104">
      <div className="max-w-3xl mx-auto" data-id="element-105">
        {/* Heading */}
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-106">
          Photographing your dog can be{' '}
          <span className="italic text-soft-gold" data-id="element-107">easier than you think</span>
        </h2>

        {/* Copy */}
        <div className="font-sans text-lg md:text-xl text-gray-300 mb-10 max-w-xl mx-auto" data-id="element-108">
          <p className="mb-6" data-id="element-109">You do not need more random photo tips.</p>
          <p className="mb-6 text-soft-gold font-medium" data-id="element-110">
            You need a simple system that helps you:
          </p>

          <ul className="space-y-3 text-left max-w-sm mx-auto mb-8" data-id="element-111">
            <li className="flex items-center" data-id="element-112">
              <span className="text-green-400 mr-3 flex-shrink-0" data-id="element-113">✓</span>
              <span data-id="element-114">understand what works</span>
            </li>
            <li className="flex items-center" data-id="element-115">
              <span className="text-green-400 mr-3 flex-shrink-0" data-id="element-116">✓</span>
              <span data-id="element-117">capture your dog's personality</span>
            </li>
            <li className="flex items-center" data-id="element-118">
              <span className="text-green-400 mr-3 flex-shrink-0" data-id="element-119">✓</span>
              <span data-id="element-120">create better memories</span>
            </li>
            <li className="flex items-center" data-id="element-121">
              <span className="text-green-400 mr-3 flex-shrink-0" data-id="element-122">✓</span>
              <span data-id="element-123">stop relying on luck</span>
            </li>
          </ul>

          <p className="text-amber-100/80" data-id="element-124">
            Because your dog deserves photos that actually do them justice.
          </p>
        </div>

        {/* CTA */}
        <button onClick={scrollToPurchase} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-sans font-bold text-lg md:text-xl py-5 px-10 rounded-full shadow-cta transition-all duration-300 transform hover:-translate-y-1 uppercase" data-id="element-125">
          👉 Get Instant Access to The Pawfect Shot MegaPack
        </button>
      </div>
    </section>;
}